import Asset from './Asset';
// look out! its own class name 'Boolean' shadows native Boolean
import BooleanProperty from './Boolean';
import Color from './Color';
import Dimensions from './Dimensions';
import DynamicGroup from './Group';
import Label from './Label';
import Number from './Number';
import Percentage from './Percentage';
import Pixels from './Pixels';
import SVGData from './SVGData';
import SVGText from './SVGText';
import Template from './Template';
import Text from './Text';

export const AllTypes = {
  SVGData,
  SVGText,
  Group: DynamicGroup,
  Number,
  Label,
  Dimensions,
  Text,
  Pixels,
  Boolean: BooleanProperty,
  Percentage,
  Color,
  Template,
  Asset,
};
